<template>
  <div>
    <nav
      class="navbar navbar-expand-lg navbar-light bg-white fixed-top main-menu"
    >
      <div
        id="overlay2"
        :style="`opacity: ${showOverlay ? '1': '0'}`"
      />
      <button
        v-if="$store.getters['authentication/is_logged_in']"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon" />
      </button>

      <a
        is="router-link"
        class="navbar-brand"
        style="margin-right: 0px"
        href="#"
        :to="logoRoute"
      >
        <img
          src="@/assets/img/egresa_logo.png"
          height="50"
          style="margin: -10px -10px"
          alt="Observatorio mi futuro"
        >
      </a>

      <a
        v-if="$store.getters['authentication/is_logged_in']"
        href="#"
        class="d-md-none"
      >
        <div
          is="router-link"
          to="/mis-favoritos"
          class="badge badge-pill badge-danger"
          :class="{overlay_class: showOverlay}"
        >{{ $store.getters['authentication/starred_amount'] }}</div>
        <fa-icon icon="star" />

      </a>

      <div
        id="navbarSupportedContent"
        class="collapse navbar-collapse"
      >
        <!-- <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#">Link</a>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle"
          href="#" id="navbarDropdown"
          role="button"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Dropdown
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" href="#">Action</a>
          <a class="dropdown-item" href="#">Another action</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="#">Something else here</a>
        </div>
      </li>
      <li class="nav-item">
        <a class="nav-link disabled" href="#">Disabled</a>
      </li>
    </ul>
    <form class="form-inline my-2 my-lg-0">
      <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
      <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
    </form> -->
        <ul
          v-if="$store.getters['authentication/is_logged_in']"
          class="navbar-nav ml-auto mr-0"
        >
          <BaseNavItem
            to="/explorador"
            title="Explorador"
            icon="compass"
          />
          <BaseNavItem
            :badge="$store.getters['authentication/starred_amount']"
            title="Mis favoritos"
            icon="star"
            :link="false"
            style="cursor: pointer;"
            :class="{overlay_class2: showOverlay}"
            @click.native="goToFavorites"
          />
          <BaseNavDropdown
            title="Mi Perfil"
            icon="user"
          >
            <a
              class="dropdown-item"
              href="#"
              @click="logout"
            >Cerrar sesión</a>
          </BaseNavDropdown>
        </ul>
      </div>
    </nav>
    <Notifications />
    <ClippyNotifications />
    <div
      :class="`container-fluid bg-light main-content padding
    ${$store.getters['authentication/is_logged_in'] ? '' : 'pt-0'}`"
    >
      <slot>Main Layout</slot>
    </div>
    <MainFooter />
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { EventBus } from '../components/EventBus';
import { studentsService } from '../_services';

export default {
    name: 'MainLayout',
    data() {
        return {
            showOverlay: false,
            student_overlay_favourites: false,
        };
    },
    computed: {
        logoRoute() {
            if (this.$store.getters['authentication/is_logged_in']) {
                return '/explorador';
            }
            return '/';
        },
    },
    mounted() {
        this.student_overlay_favourites = this.$store.getters['authentication/favourites_trigger'];
        EventBus.$on('showOverlayFavourites', this.addOverlayFavourite);
        EventBus.$on('closeOverlayFavourites', this.removeOverlayFavourite);
    },
    methods: {
        ...mapActions('authentication', ['logout']),
        goToFavorites() {
            EventBus.$emit('go-to-favorites');
        },
        addOverlayFavourite() {
            if (this.student_overlay_favourites) {
                this.showOverlay = true;
            }
        },
        removeOverlayFavourite() {
            this.showOverlay = false;
            if (this.student_overlay_favourites) {
                studentsService
                    .patchStudent(
                        this.$store.getters['authentication/student_uuid'],
                        { favourites_trigger: false },
                    ).then(() => {
                        this.$store.dispatch('authentication/triggeredFavouritesOverlay');
                    });
            }
        },
    },
};
</script>
<style lang="scss">
  .main-content{
    min-height: calc(100vh - 90px);
  }
  .main-menu{
    border-bottom: 1px solid rgba(black, 0.08);
  }
  .navbar-nav > * + *{
    border-left: solid 1px #ccc;
  }
  .overlay_class2 {
    position: relative;
    z-index: 99999;
    background-color: #dddddd;

    &--active {
      opacity: 1;
    }
  }
  #overlay2 {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 9999;
    opacity: 0;
    pointer-events: none;
    transition: opacity .3s ease;
  }
  .padding {
    padding-top: 6%;

    @media (max-width: 990px) {
      padding-top: 8%;
    }

    @media (max-width: 663px) {
      padding-top: 12%;
    }

    @media (max-width: 475px) {
      padding-top: 15%;
    }

    @media (max-width: 365px) {
      padding-top: 18%;
    }

    @media (max-width: 310px) {
      padding-top: 35%;
    }

    @media (max-width: 270px) {
      padding-top: 45%;
    }

    @media (max-width: 254px) {
      padding-top: 60%;
    }
  }
</style>
